// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ZET1","infoBtn":"quickbooks_infoBtn__2JVFg","formBox":"quickbooks_formBox__3CY3e","formFooter":"quickbooks_formFooter__2i5Y8"};